module.exports = {
  address: "0x4b7934a9937c640c560508e26c069281b0e8b84e",
  collection: "https://opensea.io/collection/cryptoogenerator",
};
